import React, { useState } from 'react';
import '../styles/Packages.css';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo3.webp'; 
import dubai from '../assets/dubai.webp';
import goa from '../assets/goa.webp';
import kerala from '../assets/kerala.webp';
import rajasthan from '../assets/jaipur.webp';
import abudhabi from '../assets/abudhabi2.webp';
import darjeeling from '../assets/darjeeling.webp';
import beach from '../assets/beaches.webp';
import ad1 from '../assets/300X600.png';
import { HiOutlineLocationMarker, HiStar, HiOutlineClock, HiTicket } from 'react-icons/hi';

const initialPackages = [
{
    id: 1,
    title: 'Dubai Desert Safari & City Tour',
    location: 'Dubai, UAE',
    description: '4 Nights, 5 Days | Desert safari, city tour, and more.',
    image: dubai,
    price: 51999,
    days: 5,
    rating: 4.8,
    hotelType: '5-star',
    activities: ['Desert Safari', 'Burj Khalifa visit', 'Dhow Cruise'],
    transferType: 'Private',
    includes: ['Breakfast', 'Dinner', 'Sightseeing'],
  },
  {
    id: 2,
    title: 'Goa Beach Escape',
    location: 'Goa',
    description: '4 Nights, 5 Days | Beaches, nightlife, and water sports.',
    image: goa,
    price: 18499,
    days: 5,
    rating: 4.6,
    hotelType: '4-star',
    activities: ['Beach visit', 'Nightclub entry', 'Parasailing'],
    transferType: 'Shared',
    includes: ['Breakfast', 'Airport pickup'],
  },
  {
    id: 3,
    title: 'Kerala Backwaters',
    location: 'Alleppey, Kerala',
    description: '5 Nights, 6 Days | Houseboats, spice plantations, and relaxation.',
    image: kerala,
    price: 22000,
    days: 6,
    rating: 4.5,
    hotelType: '4-star',
    activities: ['Houseboat stay', 'Spice plantation tour', 'Ayurvedic massage'],
    transferType: 'Shared',
    includes: ['Breakfast', 'Sightseeing', 'Airport pickup'],
  },
  {
    id: 4,
    title: 'Royal Rajasthan Tour',
    location: 'Jaipur, Jodhpur, Udaipur',
    description: '6 Nights, 7 Days | Forts, palaces, and desert safaris.',
    image: rajasthan,
    price: 24500,
    days: 7,
    rating: 4.4,
    hotelType: '4-star',
    activities: ['Fort visit', 'Camel ride', 'Cultural show'],
    transferType: 'Private',
    includes: ['Breakfast', 'Dinner', 'Local guide'],
  },
{
    id: 5,
    title: 'Abu Dhabi City & Yas Island',
    location: 'Abu Dhabi, UAE',
    description: '3 Nights, 4 Days | Grand Mosque, theme parks, and cultural sites.',
    image: abudhabi,
    price: 78000,
    days: 4,
    rating: 4.6,
    hotelType: '4-star',
    activities: ['Sheikh Zayed Grand Mosque visit', 'Ferrari World', 'Louvre Abu Dhabi'],
    transferType: 'Private',
    includes: ['Breakfast', 'Sightseeing', 'Theme park tickets'],
  },
  {
    id: 6,
    title: 'Darjeeling Tea Escape',
    location: 'Darjeeling, West Bengal',
    description: '3 Nights, 4 Days | Toy train, tea gardens, and Tiger Hill.',
    image: darjeeling,
    price: 16999,
    days: 4,
    rating: 4.3,
    hotelType: '3-star',
    activities: ['Tiger Hill', 'Tea garden visit', 'Himalayan toy train'],
    transferType: 'Shared',
    includes: ['Breakfast', 'Sightseeing'],
  },
];






const Packages = () => {
  const [filters, setFilters] = useState({
    priceLow: false,
    priceHigh: false,
    durationShort: false,
    durationLong: false,
  });

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFilters((prev) => ({ ...prev, [name]: checked }));
  };

  const applyFilters = () => {
    let filtered = [...initialPackages];

    if (filters.durationShort) {
      filtered = filtered.filter(pkg => pkg.days <= 5);
    }
    if (filters.durationLong) {
      filtered = filtered.filter(pkg => pkg.days > 5);
    }
    if (filters.priceLow && !filters.priceHigh) {
      filtered.sort((a, b) => a.price - b.price);
    } else if (filters.priceHigh && !filters.priceLow) {
      filtered.sort((a, b) => b.price - a.price);
    }

    return filtered;
  };

  const filteredPackages = applyFilters();

    const location = useLocation();
  return (
  <>
  <div className="packages-banner-wrapper">
   <header className="contact-header over-banner">
        <div className="contact-logo">
          <img src={logo} alt="Tourly Logo" />
        </div>
        <nav className="contact-nav">
          <Link to="/">Home</Link>
          <Link to="/packages" className={location.pathname === '/packages' ? 'active-link' : ''}>Packages</Link>
          <div className="contact-dropdown">
            <a href="#" className="contact-dropbtn">Destinations</a>
  
<div className="contact-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
                              <Link to="/abu">Abu Dhabi</Link>
                <Link to="/dubai">Dubai</Link>
            </div>
          </div>
            <Link to="/hotels">Hotels</Link>
        <Link to="/contact-us">Contact Us</Link>
          
        </nav>
          <Link to="/booknow">
        <button className="contact-book-btn">Book Now</button>
                                    </Link>
      </header>
  <div className="packages-main">
    <img src={beach} alt="Packages Banner" />
    <div className="overlay"></div>
    <h2 className="packages-title">Explore Our Travel Packages</h2>
  </div>
</div>

<div className="packages-content">
  {/* Modern Glass Sidebar */}
  <aside className="packages-sidebar-modern">
    <div className="sidebar-header">
      <div className="accent-line"></div>
      <h3>Refine Search</h3>
    </div>
    
    <div className="filter-section">
      <p className="filter-label">Sort by Price</p>
      <div className="modern-checkbox-group">
        <label className={`custom-checkbox ${filters.priceLow ? 'active' : ''}`}>
          <input type="checkbox" name="priceLow" checked={filters.priceLow} onChange={handleCheckboxChange} />
          <span className="checkmark"></span>
          Lowest First
        </label>
        <label className={`custom-checkbox ${filters.priceHigh ? 'active' : ''}`}>
          <input type="checkbox" name="priceHigh" checked={filters.priceHigh} onChange={handleCheckboxChange} />
          <span className="checkmark"></span>
          Highest First
        </label>
      </div>

      <p className="filter-label">Trip Duration</p>
      <div className="modern-checkbox-group">
        <label className={`custom-checkbox ${filters.durationShort ? 'active' : ''}`}>
          <input type="checkbox" name="durationShort" checked={filters.durationShort} onChange={handleCheckboxChange} />
          <span className="checkmark"></span>
          Short Stay (≤ 5 days)
        </label>
        <label className={`custom-checkbox ${filters.durationLong ? 'active' : ''}`}>
          <input type="checkbox" name="durationLong" checked={filters.durationLong} onChange={handleCheckboxChange} />
          <span className="checkmark"></span>
          Long Expedition (&gt; 5 days)
        </label>
      </div>
    </div>

    <div className="ads-container-modern">
      <span className="ad-tag">Promoted</span>
      <a href="https://www.rupay.co.in/credit-cards?utm_source=perfpartner&utm_medium=cpapplynow&utm_campaign=rupay-iplsurround&utm_id=sm-creditcard-rupay2026-creditcard-RS-static-blue-english-static-IA-424_">
        <img src={ad1} alt="Special Offer" className="ad-image-modern" />
      </a>
    </div>
  </aside>

  {/* Modern High-End Grid */}
  <div className="packages-grid-modern">
    {filteredPackages.map(pkg => (
      <div key={pkg.id} className="package-card-modern">
        <div className="card-media">
          <img src={pkg.image} alt={pkg.title} />
          <div className="card-badge">₹{pkg.price.toLocaleString()}</div>
          <div className="duration-pill"><HiOutlineClock /> {pkg.days} Days</div>
        </div>
        
        <div className="card-body">
          <div className="card-meta">
            <span className="loc-tag"><HiOutlineLocationMarker /> {pkg.location.split(',')[0]}</span>
            <span className="rating-tag"><HiStar /> {pkg.rating}</span>
          </div>
          
          <h3>{pkg.title}</h3>
          
          <div className="perks-grid">
            <div className="perk-item"><strong>Hotel:</strong> {pkg.hotelType}</div>
            <div className="perk-item"><strong>Includes:</strong> {pkg.includes[0]} & more</div>
          </div>

          <div className="activities-chips">
            {pkg.activities.slice(0, 2).map((act, i) => (
              <span key={i} className="chip"><HiTicket /> {act}</span>
            ))}
          </div>

          <div className="card-action">
            <Link to="/booknow" className="btn-modern-primary">
              View Details & Book
            </Link>
          </div>
        </div>
      </div>
    ))}
  </div>

      </div>
    </>
  );
};

export default Packages;
